import React from 'react'

import { cn } from '@/lib/utils'

interface Props {
  children: React.ReactNode
  className?: string
  inputId?: string
}

const FieldError: React.FC<Props> = ({
  children,
  className,
  inputId = 'unassigned',
}) => {
  return (
    <div
      className={cn('text-destructive mt-1 text-xs', className)}
      data-field-error={inputId}
    >
      {children}
    </div>
  )
}

export default FieldError
